import { PopupPosition } from '../effect/popup/popup-position';

export const MenuPositions: PopupPosition[] = [
  {
    x: {
      start: 'right',
      direction: 'right',
      gap: 10,
    },
    y: {
      start: 'top',
      direction: 'bottom',
      gap: -10,
    },
  },
  {
    x: {
      start: 'left',
      direction: 'left',
      gap: 10,
    },
    y: {
      start: 'top',
      direction: 'bottom',
      gap: -10,
    },
  },
  {
    x: {
      start: 'right',
      direction: 'right',
      gap: 10,
    },
    y: {
      start: 'bottom',
      direction: 'top',
      gap: -10,
    },
  },
  {
    x: {
      start: 'left',
      direction: 'left',
      gap: 10,
    },
    y: {
      start: 'bottom',
      direction: 'top',
      gap: -10,
    },
  },
];
